<template>
  <div v-if="input">
    <GameSettingTitle :input="value" @handleSaveDraft="handleSaveDraft" />
    <GameSettingTab :value="view" :input="value" @handleChangeView="handleChangeView" />
    <div class="z-border-red pa-2 pt-4">
      <div class="title">Condition</div>
      <v-divider class="my-3" />
      <v-layout wrap>
        <v-flex xs12 sm6 class="pa-1">
          <div class="caption mb-2 px-1">Start Campaign Period *</div>
          <v-layout wrap>
            <v-flex xs12 sm6 class="px-1">
              <DatepickerCustomDialog v-model="input.start_campaign_date">
                <template #default="{ computedDate }">
                  <v-text-field
                    v-validate="'required'"
                    outline
                    class="default-input"
                    placeholder="Start"
                    single-line
                    :value="computedDate"
                    name="start_campaign_date"
                    data-vv-as="Start campaign date"
                    :error="errors.has('start_campaign_date') ? true : false"
                    :error-messages="
                      errors.has('start_campaign_date') ? errors.first('start_campaign_date') : ''
                    "
                  />
                </template>
              </DatepickerCustomDialog>
            </v-flex>
            <v-flex xs12 sm6 class="px-1">
              <CustomTimepicker
                v-validate="'required'"
                :data-vv-as="'Start time'"
                :value="input.start_campaign_time"
                overlay
                format="HH:mm"
                placeholder="HH:mm"
                only-time
                clearable
                name="start_campaign_time"
                :hide-details="!errors.has('start_campaign_time')"
                :error="errors.has('start_campaign_time') ? true : false"
                :error-messages="
                  errors.has('start_campaign_time') ? errors.first('start_campaign_time') : ''
                "
                @onChange="handleChangeTime($event, 'start_campaign_time')"
              >
              </CustomTimepicker>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 sm6 class="pa-1">
          <div class="caption mb-2 px-1">End Campaign Period *</div>
          <v-layout wrap>
            <v-flex xs12 sm6 class="px-1">
              <DatepickerCustomDialog v-model="input.end_campaign_date">
                <template #default="{ computedDate }">
                  <v-text-field
                    v-validate="'required'"
                    outline
                    :value="computedDate"
                    class="default-input"
                    placeholder="End"
                    single-line
                    name="end_campaign_date"
                    data-vv-as="End campaign date"
                    :error="errors.has('end_campaign_date') ? true : false"
                    :error-messages="
                      errors.has('end_campaign_date') ? errors.first('end_campaign_date') : ''
                    "
                  />
                </template>
              </DatepickerCustomDialog>
            </v-flex>
            <v-flex xs12 sm6 class="px-1">
              <CustomTimepicker
                v-validate="'required'"
                :data-vv-as="'End time'"
                :value="input.end_campaign_time"
                overlay
                format="HH:mm"
                placeholder="HH:mm"
                only-time
                clearable
                name="end_campaign_time"
                :hide-details="!errors.has('end_campaign_time')"
                :error="errors.has('end_campaign_time') ? true : false"
                :error-messages="
                  errors.has('end_campaign_time') ? errors.first('end_campaign_time') : ''
                "
                @onChange="handleChangeTime($event, 'end_campaign_time')"
              >
              </CustomTimepicker>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs12 sm6>
          <div class="caption mb-2 px-1">Term of Play *</div>
          <v-layout wrap>
            <v-flex xs12 sm4 class="pa-1">
              <v-text-field
                v-model="input.time_to_play"
                v-validate="'required'"
                outline
                class="default-input"
                single-line
                name="time_to_play"
                data-vv-as="Time to play"
                :error="errors.has('time_to_play') ? true : false"
                :error-messages="errors.has('time_to_play') ? errors.first('time_to_play') : ''"
                @blur="$set(input, 'time_to_play', numberOnly($event))"
              />
            </v-flex>
            <v-flex
              xs12
              sm2
              class="pa-1"
              style="
                display: flex;
                flex-direction: column;
                justify-content: center;
                max-height: 54px;
              "
            >
              <div>Time Per</div>
            </v-flex>
            <v-flex xs12 sm6 class="pa-1">
              <v-select
                v-model="input.time_to_play_type"
                v-validate="'required'"
                :items="['Campaign', 'Day', 'Week', 'Month']"
                placeholder="Campaign"
                outline
                class="default-input"
                dense
                single-line
                name="time_to_play_type"
                data-vv-as="Time to play type"
                :error="errors.has('time_to_play_type') ? true : false"
                :error-messages="
                  errors.has('time_to_play_type') ? errors.first('time_to_play_type') : ''
                "
                clearable
              ></v-select>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 sm6>
          <div class="caption mb-2 px-1">Reward Condition *</div>
          <div class="pa-1">
            <v-radio-group
              v-model="input.is_limit"
              v-validate="'required'"
              class="mt-0"
              name="is_limit"
              data-vv-as="Limit"
              :hide-details="errors.has('is_limit')"
              :error="errors.has('is_limit') ? true : false"
              :error-messages="errors.has('is_limit') ? errors.first('is_limit') : ''"
            >
              <v-radio :value="true" label="จำกัดจำนวนเฉพาะ" color="primary" />
              <v-layout>
                <v-flex class="px-1">
                  <v-text-field
                    v-model="input.limits"
                    v-validate="input.is_limit ? 'required' : ''"
                    outline
                    class="default-input"
                    single-line
                    placeholder="จำนวนคน"
                    name="limits"
                    data-vv-as="Limit people"
                    :disabled="input.is_limit == false || input.is_limit == null"
                    :hide-details="errors.has('limits')"
                    :error="errors.has('limits') ? true : false"
                    :error-messages="errors.has('limits') ? errors.first('limits') : ''"
                    @blur="$set(input, 'limits', numberOnly($event))"
                  />
                </v-flex>
                <v-flex class="px-1 pt-3">
                  <div>คนแรก</div>
                </v-flex>
              </v-layout>
              <v-radio :value="false" label="แจกจนกว่าของรางวัลจะหมด" color="primary" />
            </v-radio-group>
            <div class="caption red--text">
              {{ errors.has('is_limit') ? errors.first('is_limit') : '' }}
            </div>
          </div>
        </v-flex>
      </v-layout>

      <div class="title mt-4">Message</div>
      <v-divider class="my-3" />
      <v-layout wrap>
        <v-flex xs12 sm6 class="px-1 mb-2">
          <div class="caption mb-2">Notify Message</div>
          <v-layout>
            <v-textarea
              ref="notify_message"
              v-model="input.notify_message"
              outline
              class="default-input"
              single-line
              hide-details
              name="notify_message"
              data-vv-as="Notify message"
              :error="errors.has('notify_message') ? true : false"
              :error-messages="errors.has('notify_message') ? errors.first('notify_message') : ''"
            />

            <intent-prefill
              :prefills="prefills"
              @addIntentPrefill="addPrefillMessage('notify_message', $event)"
            />
          </v-layout>
          <div class="red--text mt-1">
            <v-icon small color="red">info</v-icon> ข้อความแจ้งเตือนแก่ผู้โชคดีที่ได้รับโค้ด
          </div>
        </v-flex>
      </v-layout>

      <v-layout wrap>
        <v-flex xs12 sm6 class="px-1 mb-2">
          <div class="caption mb-2">Congratulation message on game</div>
          <v-layout>
            <v-textarea
              ref="congratulation_message"
              v-model="input.congratulation_message"
              outline
              class="default-input"
              single-line
              hide-details
              name="congratulation_message"
              data-vv-as="Congratulation message"
              :error="errors.has('congratulation_message') ? true : false"
              :error-messages="
                errors.has('congratulation_message') ? errors.first('congratulation_message') : ''
              "
            />
          </v-layout>
          <div class="red--text mt-1">
            <v-icon small color="red">info</v-icon> ข้อความแสดงความยินดีแก่ผู้โชคดีที่ได้รับโค้ด
          </div>
        </v-flex>

        <v-flex xs12 sm6 class="px-1 mb-2">
          <div class="caption mb-2">Failure message on game</div>
          <v-layout>
            <v-textarea
              ref="failure_message"
              v-model="input.failure_message"
              outline
              class="default-input"
              single-line
              hide-details
              name="failure_message"
              data-vv-as="Failure message"
              :error="errors.has('failure_message') ? true : false"
              :error-messages="errors.has('failure_message') ? errors.first('failure_message') : ''"
            />
          </v-layout>
          <div class="red--text mt-1">
            <v-icon small color="red">info</v-icon> ข้อความแสดงความเสียใจ
          </div>
        </v-flex>
      </v-layout>

      <div class="text-xs-center">
        <v-btn outline color="grey" @click="handleBack">
          {{ $t('Back') }}
        </v-btn>
        <v-btn color="primary" @click="handleSubmit()">
          {{ $t('Next') }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import CustomTimepicker from '@/components/elements/CustomTimepicker2.vue'
import DatepickerCustomDialog from '@/components/elements/DatepickerCustomDialog.vue'
import IntentPrefill from '@/components/view/intent/IntentPrefill'
import GameSettingTab from './GameSettingTab'
import GameSettingTitle from './GameSettingTitle'
export default {
  components: {
    CustomTimepicker,
    DatepickerCustomDialog,
    IntentPrefill,
    GameSettingTab,
    GameSettingTitle
  },
  inject: ['$validator'],
  props: ['value', 'view'],
  data() {
    return {
      input: null,
      prefills: [
        {
          name: `${this.$t('Insert')}${this.$t('first name')}`,
          value: 'first_name',
          description: ''
        },
        {
          name: `${this.$t('Insert')}${this.$t('last name')}`,
          value: 'last_name',
          description: ''
        },
        {
          name: `${this.$t('Insert')} ${this.$t('Code')}`,
          value: 'code',
          description: ''
        }
      ]
    }
  },
  watch: {
    'input.is_limit': function (newVal, oldVal) {
      if (newVal != oldVal && newVal == false) {
        this.input.limits = null
      }
    }
  },
  mounted() {
    if (this.value) {
      this.input = this.value
    }
  },
  methods: {
    handleChangeTime(val, type) {
      this.input[type] = val
    },
    async handleSaveDraft() {
      this.$emit('handleSaveDraft')
    },
    async handleChangeView(view) {
      const vm = this
      vm.handleSubmit(() => {
        vm.$emit('handleSubmit', { view: view, data: vm.input })
      })
    },
    handleBack() {
      this.$emit('handleSubmit', { step: 1, data: this.input })
    },
    async handleSubmit(callback) {
      const result = await this.$validator.validateAll()
      if (!result) {
        // do stuff if not valid.
        this.goToErrorInput()
        return false
      }
      if (callback) {
        callback()
      } else {
        this.$emit('handleSubmit', { step: 3, data: this.input })
      }
    },
    addPrefillMessage(type, prefill) {
      const ref = this.$refs[type]
      const cursorPosition = ref.$el.querySelector('textarea').selectionStart
      const str = this.input[type] || ''
      this.input[type] = [
        str.slice(0, cursorPosition),
        '{' + prefill + '}',
        str.slice(cursorPosition)
      ].join('')
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/generalixwarroom/GameSetting/Condition.vue